import {
  ApartmentCategoryEnum,
  HouseCategoryEnum,
  LandCategoryEnum,
  OfficeCategoryEnum,
  PurposeEnum,
  Search,
  TypeEnum,
} from "@/types/types";
import styles from "../page-searchbar.module.css";
import { useEffect, useRef, useState } from "react";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import { getCategoryOptions } from "@/lib/getCategories/getCategoryOptins";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { IoIosArrowDown } from "react-icons/io";

export default function CategorySelectorClient({
  t,
  type,
  activeCategory,
  updateSearch,
  refetchState,
  fullWidth,
  isMobileStyle,
}: {
  t: any;
  type: TypeEnum;
  activeCategory:
    | ApartmentCategoryEnum
    | HouseCategoryEnum
    | LandCategoryEnum
    | OfficeCategoryEnum
    | null;
  updateSearch: <K extends keyof Search>(key: K, value: Search[K]) => void;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
  isMobileStyle?: boolean;
}) {
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const categoryListRef = useRef<HTMLDivElement>(null);
  const categoryListStyles = useDropdownPosition(
    categoryListRef,
    isCategoryOpen,
    {
      customWidth: 180, // px
      fullWidth: fullWidth,
    }
  );
  const categories = getCategoryOptions(type);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        categoryListRef.current &&
        !categoryListRef.current.contains(event.target as Node)
      ) {
        setIsCategoryOpen(false); //this will close it
      }
    };
    if (isCategoryOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCategoryOpen]);

  return (
    <div
      className={`${styles.selectWrapper} ${styles.categoryItemWrapper} ${
        fullWidth && styles.fullWidth
      } ${isMobileStyle && styles.mobile}`}
      ref={categoryListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsCategoryOpen(!isCategoryOpen);
        }}
        className={`${styles.pill} ${isCategoryOpen && styles.pillOpen}`}
      >
        <div className={styles.textWrapper}>
          <span>
            {activeCategory !== null && activeCategory !== undefined
              ? t(activeCategory)
              : t("categoryTitle")}
          </span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
      {isCategoryOpen && categoryListStyles.top && (
        <ul className={`${styles.selectionList}`} style={categoryListStyles}>
          <SelectorComponentListItem
            text={t("any")}
            icon={null}
            isActive={activeCategory === null || activeCategory === undefined}
            onClick={async () => {
              updateSearch("category", null);
              updateSearch("office_type", null);
              setIsCategoryOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          {categories.map((category, index) => {
            return (
              <SelectorComponentListItem
                key={index + category}
                text={t(category)}
                icon={null}
                isActive={activeCategory === category}
                onClick={async () => {
                  updateSearch("category", category);
                  updateSearch("office_type", null);
                  setIsCategoryOpen(false);
                  await refetchState();
                }}
                isSearchbar={true}
              />
            );
          })}
        </ul>
      )}
    </div>
  );
}
